import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Tab } from "@pentabd/ui";
import {
  DistributionListTable,
  AssetsListTable,
  ProductListTable,
  ItemsListTable,
} from ".";

const StockBody = () => {
  const { t } = useTranslation();

  const [currentTab, setCurrentTab] = useState(0);
  const handleActiveTab = (tabIndex: number) => setCurrentTab(tabIndex);

  const moduleName = localStorage.getItem("module");

  const tabData = [
    {
      label: t("INVENTORY_STOCK.TABS.ITEMS"),
      component: <ProductListTable />,
    },
    {
      label: t("INVENTORY_STOCK.TABS.DISTRIBUTION"),
      component: <DistributionListTable />,
    },
    {
      label:
        moduleName?.toLowerCase() === "inventory"
          ? t("INVENTORY_STOCK.TABS.ASSETS")
          : "",
      component:
        moduleName?.toLowerCase() === "inventory" ? <AssetsListTable /> : <></>,
    },
    {
      label: t("INVENTORY_STOCK.TABS.ITEMS_LIST"),
      component: <ItemsListTable />,
    },
  ];

  return (
    <div className="mt-10">
      <Tab active={currentTab} setActiveTab={handleActiveTab}>
        <Tab.Heads>
          {tabData.map(({ label }, i) => (
            <Tab.Item key={i} index={i} label={label} />
          ))}
        </Tab.Heads>
        <Tab.ContentWrapper>
          {tabData.map(({ component }, i) => (
            <Tab.Content index={i} key={i}>
              <div className="py-7">{component}</div>
            </Tab.Content>
          ))}
        </Tab.ContentWrapper>
      </Tab>
    </div>
  );
};

export default StockBody;
